<div class="layout-row full-height margin-right-5">
  <bringoz-icon iconName="relation"
                fill="#7E7E7E"
                [ngbTooltip]="tooltipTmpl"
                openDelay="300"
                triggers="hover">
  </bringoz-icon>
  <span class="md-tiny">{{count}}</span>

  <ng-template #tooltipTmpl>
    <span>{{count}} {{'Linked tasks' | translate}}</span>
  </ng-template>
</div>
